<template lang="pug">
div
    h4(style='font-weight: 800; color: #5a5a5a; margin-bottom: 10px') {{ $t('mensagens.territorio.arquivo.tituloProdutor') }}
    el-card(style='min-height: 195px')
        h4(style='color: #5a5a5a; margin-bottom: 20px; font-weight: 500') {{ $t('mensagens.territorio.arquivo.subTituloAr') }}
        UploadArquivo(
            style='margin-bottom: 15px',
            @add='onAdd',
            @delete='onDelete',
            :options='items'
        )
            | {{
            |
            | $t('mensagens.territorio.arquivo.arquivo')
            |
            | }}

        //- el-card(v-else)
        //-     el-alert(
        //-         show-icon='',
        //-         type='warning',
        //-         :title='$t("mensagens.territorio.arquivo.atencao")'
        //-     )
</template>
<script>
import UploadArquivo from './UploadArquivoAr.vue';

export default {
    components: {
        UploadArquivo
    },
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        onAdd(file) {
            this.$emit('add', file);
        },
        onDelete(index) {
            this.$emit('delete', index);
        }
    }
};
</script>
